import * as types from '../../mutation-types'

const state = {
  donationType: null,
  donationAmount: null,
  paymentRequested: false,
  PSSaleRequested: false
}

// getters
const getters = {
  donationType: state => state.donationType,
  donationAmount: state => state.donationAmount
}

const actions = {
  changeDonationType ({commit}, a) {
    console.log(a)
    commit(types.CHANGE_DONATIONS_TYPE, a)
  },
  changeDonationAmount ({commit}, a) {
    commit(types.CHANGE_DONATIONS_AMOUNT, a)
  }
}

const mutations = {
  [types.PAYMENT_REQUESTED] (state, s) {
    state.paymentRequested = s
  },
  [types.CHANGE_DONATIONS_TYPE] (state, a) {
    state.donationType = a
    // TODO: Remove this if not required
    localStorage.setItem('donation-type', a)
  },
  [types.CHANGE_DONATIONS_AMOUNT] (state, a) {
    state.donationAmount = a
    // TODO: Remove this if not required
    localStorage.setItem('donation-amount', a)
  },
  [types.PAYMENT] (state) {
    state.paymentRequestStatus = false
    state.paymentDoneStatus = null
    localStorage.setItem('payment-req-status', '')
    localStorage.setItem('payment-status', false)
  },
  [types.PAYMENT_SUCCESS] (state, paymentObject) {
    state.paymentRequestStatus = paymentObject
    localStorage.setItem('payment-req-status', JSON.stringify(paymentObject))
    setTimeout(() => {
      state.paymentDoneStatus = true
      localStorage.setItem('payment-status', true)
    }, 6000)
  },
  [types.PAYMENT_FAILURE] (state, reason) {
    state.paymentRequestStatus = false
    localStorage.setItem('payment-req-status', reason)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/donation-details/index.js